/**
 * Video Player.
 * 
 */

/**
 * Simple video player. Only a play button.
 */

// Select the HTML5 video
let
	$videoContainer = $('#video-container'),
	$video = $('#video'),
	$playButton = $videoContainer.find('.button-play-video'),
	$controls = $videoContainer.find('.controls');

function initVideoPlayer() {
	console.log('VIDEOPLAYER: initVideoPlayer()');

	$controls.on('click', function(event) {
		console.log('VIDEOPLAYER: CLICK .controls');
        event.preventDefault();
		$controls.fadeOut(300);
		// $controls.addClass('hide');
		// $video.fadeIn(300);
		// $videoContainer.find('.poster-frame').fadeOut(300);
		video.play();
		$videoContainer.addClass('playing');
	});

	$video.on('click', function(event) {
		console.log('VIDEOPLAYER: CLICK #video');
        event.preventDefault();
		$controls.fadeIn(300);
		// $controls.removeClass('hide');
		// $video.fadeOut(300);
		// $videoContainer.find('.poster-frame').fadeIn(300);
		video.pause();
		$videoContainer.removeClass('playing');
	});

	// $video.addEventListener('webkitendfullscreen', function (e) { 
	// 	console.log('VIDEOPLAYER: MOBILE VIDEO CLOSE');
	// 	$controls.fadeIn(300);
	// 	$video.fadeOut(300);
	// });
}

exports.init = function () {
	// console.log('VIDEO PLAYER: exports.init');
    // Run init methods...

	initVideoPlayer();
};